import crypto_js from 'crypto-js';

export const getSignature = (email, google_user_id) => {
    let secretKey = process.env.REACT_APP_SECRET_KEY;
    let signature = email + google_user_id + secretKey;
    return crypto_js.MD5(signature).toString().toUpperCase();
}